import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserProfile } from './user-profile.model';
import { Subscription } from 'rxjs';
import { HttpRepositoryService } from '../core/http-repository.service';


declare var Toast: any;

@Component({
    selector: 'user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css']
})

export class UserProfileComponent implements OnInit, OnDestroy {
  private user: UserProfile = new UserProfile();

  private subscriptions: Subscription[] = [];
  private getUserSub: Subscription;

  constructor(private repository: HttpRepositoryService) { }

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.getUserSub = this.repository.get<UserProfile>('api/User/Details').subscribe(resp => {
      if (resp.hasErrors) {
        Toast.Show(resp.error, 'Can\'t find user.', 'error');
      } else {
        this.user = resp.data
      }
    });

    this.subscriptions.push(this.getUserSub);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
}

